export default {"src":"/_next/static/media/tree.ac32bd7f.svg","height":32,"width":24,"blurWidth":0,"blurHeight":0};